import { useState } from 'react'
import { Link, useSearchParams } from 'react-router-dom'
import { resetPassword } from '../services/api'
import AuthSplit from '../components/AuthSplit'

const fieldClass =
  'w-full h-10 px-3 rounded-lg border border-line bg-canvas text-ink text-sm outline-none focus:ring-2 focus:ring-accent'

export default function ResetPasswordPage() {
  const [params] = useSearchParams()
  const token = params.get('token') || ''
  const [password, setPassword] = useState('')
  const [confirm, setConfirm] = useState('')
  const [error, setError] = useState('')
  const [done, setDone] = useState('')
  const [loading, setLoading] = useState(false)

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setError('')
    if (password !== confirm) {
      setError('As senhas não coincidem')
      return
    }
    setLoading(true)
    try {
      const data = await resetPassword(token, password)
      setDone(data.detail)
    } catch (err: unknown) {
      const detail = (err as { response?: { data?: { detail?: string } } })?.response?.data?.detail
      setError(detail || 'Não foi possível redefinir a senha')
    } finally {
      setLoading(false)
    }
  }

  return (
    <AuthSplit>
      <h1 className="text-2xl font-semibold m-0">Nova senha</h1>
      <p className="text-sm text-muted mt-1.5 mb-6">O link vale 30 minutos e só pode ser usado uma vez.</p>
      {!token && (
        <p className="text-sm text-bad">Este endereço não tem um token de redefinição.</p>
      )}
      {done ? (
        <div className="flex flex-col gap-4">
          <p className="text-sm m-0">{done}</p>
          <Link to="/login" className="h-10 rounded-lg bg-ink text-surface font-semibold inline-flex items-center justify-center">Entrar</Link>
        </div>
      ) : (
        <form onSubmit={handleSubmit} className="flex flex-col gap-4">
          {error && <div className="p-3 rounded-lg bg-bad/10 text-bad text-sm">{error}</div>}
          <div>
            <label htmlFor="reset-password" className="block text-sm font-medium mb-1">Nova senha</label>
            <input id="reset-password" type="password" required minLength={8} value={password} onChange={(e) => setPassword(e.target.value)} className={fieldClass} disabled={!token} />
          </div>
          <div>
            <label htmlFor="reset-confirm" className="block text-sm font-medium mb-1">Confirmar senha</label>
            <input id="reset-confirm" type="password" required minLength={8} value={confirm} onChange={(e) => setConfirm(e.target.value)} className={fieldClass} disabled={!token} />
          </div>
          <button type="submit" disabled={loading || !token} className="h-10 rounded-lg bg-ink text-surface font-semibold cursor-pointer disabled:opacity-50">
            {loading ? 'Salvando...' : 'Salvar senha'}
          </button>
        </form>
      )}
    </AuthSplit>
  )
}
